import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import Layout, { StatusBadge } from '../components/Layout'
import { MeetingForm } from '../components/Forms'
import { Btn, Card, Empty, Msg, fmtDateTime } from '../components/ui'
import { clientLabel, type Client, type Meeting } from '../lib/db'

export default function Rencontres() {
  const [params, setParams] = useSearchParams()
  const [meetings, setMeetings] = useState<Meeting[]>([])
  const [clients, setClients] = useState<Client[]>([])
  const [form, setForm] = useState<Partial<Meeting> | null>(params.get('new') ? {} : null)
  const [msg, setMsg] = useState('')

  async function load() {
    const [m, c] = await Promise.all([supabase.from('meetings').select('*').order('meeting_date', { ascending: false }), supabase.from('clients').select('*').order('company').order('full_name')])
    setMeetings((m.data as any) || []); setClients((c.data as any) || [])
  }
  useEffect(() => { load() }, [])
  const cname = (id: string | null) => id ? clientLabel(clients.find(c => c.id === id)) : '—'
  const close = () => { setForm(null); setParams({}) }
  const now = Date.now()
  const upcoming = meetings.filter(m => new Date(m.meeting_date).getTime() >= now - 3600e3 && m.status !== 'annulé').sort((a, b) => a.meeting_date.localeCompare(b.meeting_date))
  const past = meetings.filter(m => !upcoming.includes(m))

  async function setStatus(m: Meeting, status: string) { await supabase.from('meetings').update({ status }).eq('id', m.id); load() }
  async function remove(m: Meeting) {
    if (!confirm(`Supprimer « ${m.title} » ?`)) return
    const { error } = await supabase.from('meetings').delete().eq('id', m.id)
    if (error) setMsg('Erreur : ' + error.message); else load()
  }

  const Row = ({ m }: { m: Meeting }) => (
    <div className="flex flex-wrap items-center justify-between gap-3 py-3 border-t border-white/5 first:border-0 text-sm">
      <div className="min-w-0 flex-1">
        <button onClick={() => setForm(m)} className="font-medium hover:text-orange text-left">{m.title}</button>
        <div className="text-xs text-acier">{cname(m.client_id)} · {m.platform} · {m.duration_minutes} min</div>
        {m.notes && <div className="text-xs text-acier mt-1 line-clamp-2">{m.notes}</div>}
      </div>
      <div className="text-right text-xs">
        <div className="text-orange">{fmtDateTime(m.meeting_date)}</div>
        <div className="flex items-center gap-3 mt-1 justify-end uppercase tracking-widest">
          {m.meeting_url && <a href={m.meeting_url} target="_blank" rel="noreferrer" className="text-acier hover:text-orange">Rejoindre</a>}
          {m.status === 'planifié' && <button onClick={() => setStatus(m, 'terminé')} className="text-green-300 hover:underline">Terminée</button>}
          <button onClick={() => remove(m)} className="text-acier hover:text-red-300">×</button>
          <StatusBadge status={m.status} />
        </div>
      </div>
    </div>
  )

  return (
    <Layout title="Rencontres" actions={<Btn onClick={() => setForm({})}>+ Nouvelle rencontre</Btn>}>
      <Msg msg={msg} />
      <div className="space-y-6 mt-2">
        <Card title={`À venir (${upcoming.length})`}>{upcoming.length === 0 ? <Empty>Aucune rencontre planifiée.</Empty> : upcoming.map(m => <Row key={m.id} m={m} />)}</Card>
        <Card title={`Passées (${past.length})`}>{past.length === 0 ? <Empty>Aucune.</Empty> : past.slice(0, 30).map(m => <Row key={m.id} m={m} />)}</Card>
      </div>
      {form && <MeetingForm initial={form} clients={clients} onClose={close} onSaved={() => { close(); load() }} />}
    </Layout>
  )
}
